// extracted by mini-css-extract-plugin
export default {"CustomHeaderContainer":"CustomHeader_CustomHeaderContainer__L1cuP","IconContainer":"CustomHeader_IconContainer__3Bz36","TypicalH2":"CustomHeader_TypicalH2__M0zd4"};